import { render, staticRenderFns } from "./categoriesList.vue?vue&type=template&id=71fef1a4&scoped=true&"
import script from "./categoriesList.vue?vue&type=script&lang=js&"
export * from "./categoriesList.vue?vue&type=script&lang=js&"
import style0 from "./categoriesList.vue?vue&type=style&index=0&id=71fef1a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fef1a4",
  null
  
)

export default component.exports